/**
 * Copyright (c) 2022 Schwäbische Werkzeugmaschinen GmbH
 *
 * @author Sebastian Roming
 * @since 5.0.0
 */
import { baseConfig } from '../auto-generated/config';
import browser        from 'browser-detect';
import { showToast }  from './show-toast';


// --------------------------------------------------------------------------------------
export const isInMaintenanceMode = () => {
  return baseConfig.maintenanceMode.activated;
};

// --------------------------------------------------------------------------------------
export const isMaintenanceAnnouncement = () => {
  return baseConfig.maintenanceAnnouncement.activated;
};

export const checkFormFieldsDisabled = () => {
  return isInMaintenanceMode() || !isAllowedBrowser();
}

// --------------------------------------------------------------------------------------
export const isAllowedBrowser = () => {
  const _browser = browser();

  if (baseConfig.allowedBrowsers.indexOf(_browser.name!) === -1) {
    showToast('not_supported_browser');
    return false;
  }

  return true;
}

// --------------------------------------------------------------------------------------
export const storeLoginCredentials = async (credentials: any) => {
  try {
    Promise.resolve(window.localStorage.setItem(baseConfig.localstorage.token_key, JSON.stringify(credentials)));
  } catch (error) {
    console.error('Error writing to localStorage:', error);
  }
};

export const redirectTo = (url: string) => window.location.href = url;